import React, { useState } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import Card from '../../../components/Card'
import { useNavigate } from 'react-router-dom'
import { useCreateMlmAccountMutation } from '../../../api/mlmAccountsAPISlices'
import Toaster from '../../../components/utility/Toaster'

const MlmAccountsAdd = () => {
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [clientId, setClientId] = useState('');
    const [clientSecret, setClientSecret] = useState('');
    const [baseUrl, setBaseUrl] = useState('');
    const [oauthUrl, setOauthUrl] = useState('');
    const [showSecret, setShowSecret] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [showToster, setShowToster] = useState(false);
    const [tosterMassage, setTosterMassage] = useState('');
    const [tosterStatus, setTosterStatus] = useState('');

    const [createMlmAccount] = useCreateMlmAccountMutation();

    const token = JSON.parse(localStorage.getItem("token"));

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name.trim() || !clientId.trim() || !clientSecret.trim()) {
            setShowToster(true);
            setTosterMassage('Name, Client ID, and Client Secret are required.');
            setTosterStatus('error');
            return;
        }

        setIsSubmitting(true);

        const payload = {
            name: name.trim(),
            client_id: clientId.trim(),
            client_secret: clientSecret,
        };

        if (baseUrl.trim()) payload.base_url = baseUrl.trim();
        if (oauthUrl.trim()) payload.oauth_url = oauthUrl.trim();

        await createMlmAccount({ payload, token })
            .unwrap()
            .then(() => {
                navigate('/mlm-accounts');
            })
            .catch((error) => {
                setShowToster(true);
                setTosterMassage(error?.data?.message || 'Error creating MLM account');
                setTosterStatus('error');
                setIsSubmitting(false);
            });
    };

    return (
        <>
            <Container fluid>
                <Row className="mb-4">
                    <Col>
                        <div className="d-flex align-items-center gap-3">
                            <Button
                                variant="light"
                                className="d-flex align-items-center gap-2"
                                onClick={() => navigate('/mlm-accounts')}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                </svg>
                                Back
                            </Button>
                            <div>
                                <h4 className="mb-0">Add MLM Account</h4>
                                <small className="text-muted">Create a new MLM account integration</small>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col lg="8">
                        <Card className="border-0 shadow-sm">
                            <Card.Body className="p-4">
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter account name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Client ID <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter client ID"
                                            value={clientId}
                                            onChange={(e) => setClientId(e.target.value)}
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Client Secret <span className="text-danger">*</span></Form.Label>
                                        <div className="input-group">
                                            <Form.Control
                                                type={showSecret ? 'text' : 'password'}
                                                placeholder="Enter client secret"
                                                value={clientSecret}
                                                onChange={(e) => setClientSecret(e.target.value)}
                                                required
                                            />
                                            <Button
                                                variant="outline-secondary"
                                                type="button"
                                                onClick={() => setShowSecret(!showSecret)}
                                            >
                                                {showSecret ? (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                                    </svg>
                                                ) : (
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                    </svg>
                                                )}
                                            </Button>
                                        </div>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Base URL <span className="text-muted small">(optional)</span></Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="e.g. https://mlm.example.com"
                                            value={baseUrl}
                                            onChange={(e) => setBaseUrl(e.target.value)}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-4">
                                        <Form.Label>OAuth URL <span className="text-muted small">(optional)</span></Form.Label>
                                        <Form.Control
                                            type="url"
                                            placeholder="e.g. https://mlm.example.com/oauth/token"
                                            value={oauthUrl}
                                            onChange={(e) => setOauthUrl(e.target.value)}
                                        />
                                    </Form.Group>

                                    <div className="d-flex gap-3">
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                    Creating...
                                                </>
                                            ) : 'Create Account'}
                                        </Button>
                                        <Button
                                            type="button"
                                            variant="light"
                                            onClick={() => navigate('/mlm-accounts')}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Toaster status={tosterStatus} message={tosterMassage} show={showToster} setShow={setShowToster} />
        </>
    )
}

export default MlmAccountsAdd;
